import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ProductFacetDto } from './ProductFacetDto'
/**
* Class ProductFacetsDto
*  Агрегаты фасетных фильтров витринного каталога
*/
export class ProductFacetsDto extends ActiveModel {

  /**
  * matchedCardsCount
  * Число карточек в полном срезе фильтров (как выдача search без пагинации)<br>  */
  @ActiveField(0)
  matchedCardsCount: number = 0


/**
  * @property facets
  * Фасеты запрошенной категории, по возрастанию `attributeId`  */
  @ActiveField({
    factory: [ProductFacetDto, () => []]
  })
  facets: Array<ProductFacetDto> = []
}
